export default __webpack_public_path__ + "static/media/elearning-bg.0e19430a.png";